import { T, useTheme, dens, Ico, Card, Eyebrow } from '../../../design';
import type { Employee } from '../../../types/portal.types';
import { PersonRow } from './PersonRow';

export interface AdminEmployeesProps {
  salonName: string;
  employees: Employee[];
  onPick: (employee: Employee) => void;
}

export function AdminEmployees({ salonName, employees, onPick }: AdminEmployeesProps) {
  const t = useTheme();
  const d = dens(t);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: d.gap }}>
      <Card pad={14}>
        <Eyebrow color={t.accent}>Valgt salon</Eyebrow>
        <div style={{ fontSize: 16, fontWeight: 800, color: T.fg, marginTop: 4 }}>{salonName}</div>
      </Card>
      <Eyebrow>Ager som medarbejder</Eyebrow>
      <Card pad={0}>
        {employees.map((emp) => <PersonRow key={emp.id} name={emp.name} owner={emp.isOwner} onClick={() => onPick(emp)} right={<Ico.chevR size={18} style={{ color: T.fg3 }} />} />)}
      </Card>
    </div>
  );
}
